import React, { useEffect, useState } from 'react';
import UploadCSVFilesTable from '../../components/UploadCSVFilesTable/UploadCSVFilesTable';
import { IO_ALLOCATION_BULK_UPLOAD, IO_ALLOCATION_BULK_DOWNLOAD } from '../../api/endpoints';
import MastersTabBar from '../../components/Common/MastersTabBar/MastersTabBar';

const IoAllocationUploadFiles = () => {

     const defaultData = [
        { key: '1', title: 'IO Allocation', fileName: 'io_allocation.csv' },
     ];

    return (
        <div className="px-6 pt-3">
            <MastersTabBar activeId="ioAllocation" />
            <UploadCSVFilesTable defaultData={defaultData} uploadApi = {IO_ALLOCATION_BULK_UPLOAD} downloadApi ={IO_ALLOCATION_BULK_DOWNLOAD}/>
        </div>
    )
};

export default IoAllocationUploadFiles;